module.exports = __webpack_public_path__ + "img/icon-team-plus.96463627.png";